export const RoofIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.875 7.91667C17.2202 7.91667 17.5 8.19649 17.5 8.54167V15C17.5 16.3807 16.3807 17.5 15 17.5H5C3.61929 17.5 2.5 16.3807 2.5 15V8.54167C2.5 8.19649 2.77982 7.91667 3.125 7.91667H16.875ZM3.75 15C3.75 15.6904 4.30964 16.25 5 16.25H15C15.6904 16.25 16.25 15.6904 16.25 15V9.16667H3.75V15Z"
        fill="#101828"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.625 2.5C16.6605 2.5 17.5 3.33947 17.5 4.375V6.04167C17.5 6.38684 17.2202 6.66667 16.875 6.66667H3.125C2.77982 6.66667 2.5 6.38684 2.5 6.04167V4.375C2.5 3.33947 3.33947 2.5 4.375 2.5H15.625ZM4.375 3.75C4.02982 3.75 3.75 4.02982 3.75 4.375V5.41667H16.25V4.375C16.25 4.02982 15.9702 3.75 15.625 3.75H4.375Z"
        fill="#101828"
      />
    </svg>
  );
};
